<template>
  <div class="card mat10">
    <div class="flex-sb-c" style="border-bottom:1px solid #E6E6E6;padding:10px 20px 20px 20px">
      <div class="flex-s-c">
        <div class="flex-s-c">
          <template v-if="!$route.params.other">
            <!-- // 1待开始 2 进行中 3 未完成 4已完成 5 待取消 6已取消 -->
            <template v-if="detail.status==1">
              <i class="iconfont icon-order status-iconfont"></i>
              <span class="status-text">待开始</span>
            </template>
            <template v-if="detail.status==2">
              <i class="iconfont icon-shenhezhong1 status-iconfont"></i>
              <span class="status-text">进行中</span>
            </template>
            <template v-if="detail.status==3">
              <i class="iconfont icon-shenhezhong status-iconfont"></i>
              <span class="status-text">审核中</span>
            </template>
            <template v-if="detail.status==4">
              <i class="iconfont icon-yiwancheng status-iconfont"></i>
              <span class="status-text">已完成</span>
            </template>
            <template v-if="detail.status==6">
              <i class="iconfont icon-weiwanchengrenwushu status-iconfont"></i>
              <span class="status-text">已取消</span>
            </template>
            <template v-if="detail.status==5">
              <i class="iconfont icon-order status-iconfont"></i>
              <span class="status-text">待取消</span>
            </template>
          </template>
          <template v-else>
            <!-- 5对应审核中  6对应 通过  其他的状态对应驳回 -->
            <template v-if="detail.status==5">
              <i class="iconfont icon-shenhezhong status-iconfont"></i>
              <span class="status-text">审核中 </span>
            </template>
            <template v-else-if="detail.status==6">
              <i class="iconfont icon-yiwancheng status-iconfont"></i>
              <span class="status-text">已通过</span>
            </template>
            <template v-else>
              <i class="iconfont icon-weiwanchengrenwushu status-iconfont"></i>
              <span class="status-text">已驳回</span>
            </template>
          </template>
        </div>
        <!-- <div style="text-align: center;margin-left:60px">
          <div class="fontcolor-grey ">距活动时间</div>
          <div>剩余22时33分</div>
        </div> -->
      </div>
      <el-button type="primary" @click="showModal" v-if="detail.status==1">退出报名</el-button>
    </div>
    <div class="title-border">
      <span class="name">活动详情</span>
    </div>
    <div class="flex-s-s" style="position: relative;">
      <img :src="detail.photo" class="img" v-if="$route.params.type == 'plan'||$route.params.type == 'activity'" />
      <div style="margin-left:20px">
        <div class="title-md">{{detail.activityName}}</div>
        <template v-for="item in messageList">
          <div class="fontcolor-grey mat20"> {{item.title}}</div>
          <ul class="key-value">
            <li v-for="cItem in item.fieldList">
              <div class="key">{{cItem.taskFieldKey}}：</div>
              <div class="value">{{cItem.taskFieldValue}}</div>
            </li>
          </ul>
        </template>
      </div>
    </div>
    <div class="fontcolor-grey mat20" v-if="$route.params.type=='plan'||$route.params.type=='activity'"> 活动说明：</div>
    <div class="mat10" style="line-height:30px" v-html="detail.remark"></div>
    <!-- <div class="fontcolor-grey mat20"> 报名时间：</div>
    <div class="mat10" style="line-height:30px"> 晒出你</div>
    <div class="fontcolor-grey mat20"> 申请就餐：</div>
    <div class="mat10" style="line-height:30px"> sss</div> -->
    <!-- <m-modal :dialog-visible="dialogVisible" @on-close="closeDialog" @on-submit="getDialog" title="确认" :content="modalContent"></m-modal> -->
  </div>
</template>

<script>
import mModal from '@/components/modal/modal.vue'
export default {
  components: {
    mModal
  },
  data() {
    return {
      detail: {},
      taskDetailList: [],
      dialogVisible: false,
      modalContent: { icon: "icon-tanhao", iconColor: "#FF7200", title: "确认取消活动吗？", tips: "点击确定按钮，申请取消活动，申请后需要后台审核通过，才能取消活动" },
      messageList: [],
      userMess: this.$store.state.user.user,
    };
  },
  computed: {},
  watch: {},
  methods: {
    getDetail() {
      let type
      // 1讲解 2服务 3策划 4其他活动 
      if (this.$route.params.type == 'explain') type = 1
      else if (this.$route.params.type == 'service') type = 2
      else if (this.$route.params.type == 'plan') type = 3
      else if (this.$route.params.type == 'activity') type = 4

      let params = {
        activityType: type,
        taskSignId: this.$route.params.id
      }
      this.$route.params.other ? params.cancelFlag = 1 : "",
        this.$api.getDetailInfo(params).then(res => {
          this.detail = res.data
          this.messageList = res.data.taskDetailList
          // console.log(res)
        })
    },
    showModal() {
      let _this = this
      let type
      // // 1讲解 2服务 3策划 4其他活动 
      if (_this.$route.params.type == 'explain') type = 1
      else if (_this.$route.params.type == 'service') type = 2
      else if (_this.$route.params.type == 'plan') type = 3
      else if (_this.$route.params.type == 'activity') type = 4
      let params1 = {
        activityType: type,
        cancelReason: "",
        taskSignId: _this.$route.params.id,
      }
      this.$api.cancelBefore(params1).then(res => {
        if (res.code == 1) {
          let content = res.data ? this.modalContent.tips + '(' + res.data + ')' : this.modalContent.tips
          this.$tips({
            title: "确认",
            head: _this.modalContent.title,
            icon: _this.modalContent.icon,
            content: content,
            confirm: true,
            cancel: true,
            dialogVisible: true,
            btn: {
              confirmVal: "确定",
              cancelVal: "取消"
            }
          }).then((res) => {
            let params = {
              activityType: type,
              cancelReason: "",
              taskSignId: _this.$route.params.id,
              volunteerId: _this.userMess.id
            }
            // console.log(params)
            _this.$api.cancelTask(params).then(res => {
              if (res.code == 1) {
                _this.$message.success(res.message);
                _this.getDetail()
              } else {
                // console.log("sss")
                _this.$message.error(res.message);
              }
            })
            // console.log("yes", res);
            //点击确定之后的处理
          }).catch((err) => {
            // console.log("no", err);
          });
        } else {
          this.$tips({
            title: "确认",
            // head: _this.modalContent.title,
            icon: _this.modalContent.icon,
            content: res.data,
            confirm: true,
            // cancel: true,
            dialogVisible: true,
            btn: {
              confirmVal: "确定",
              // cancelVal: "取消"
            }
          }).then((res) => {

          }).catch((err) => {
            // console.log("no", err);
          });
        }
      })
      // let _this = this

    },
    //获取弹框内所填信息
    getDialog(array) {
      /** 
      * array[0] 所选弹框类型
      * array[1] 弹框携带的返回1数据
      * type [explain]讲解,
      *      [service]服务
     */
      let type = array[0];
      let data = array[1];


      this.dialogVisible = true
    },
    // 关闭弹框
    closeDialog() {
      this.dialogVisible = false
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getDetail()
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
// @import "./service.css";
.img {
  width: 500px;
  height: 312.5px;
}
.title-md {
  font-size: 22px;
}
// .status-iconfont {
//   margin-right: 10px;
//   border-radius: 30px;
//   font-size: 40px;
//   padding: 10px;
//   background: #007083;
//   color: #fff;
// }
// .status-text {
//   color: @bg-green;
//   font-size: 20px;
//   font-weight: bold;
// }
</style>
